import React from "react";
import styled from "styled-components";
import { IoIosCart } from "react-icons/io";

const Wrapper = styled.button`
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%) translateX(2.5px);
  height: 70px;
  width: 35px;
  background: black;
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;
  z-index: 100;
  p {
    color: white;
    position: absolute;
    top: 0;
    right: 50%;
    transform: translateX(50%) translateX(-1.25px);
  }
  svg {
    position: absolute;
    bottom: 4px;
    right: 50%;
    transform: translateX(50%) translateX(-1.25px);
  }
`;

export interface CartButtonProps {
  className?: string;
  onClick: () => void;
  amountItems: number;
}

export const CartButton: React.FC<CartButtonProps> = ({
  className,
  onClick,
  amountItems,
}) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <p>{amountItems}</p>
      <IoIosCart color="white" size={26} />
    </Wrapper>
  );
};
